import get from 'lodash/get'
import React from 'react'
import Card from '../Card'
import SelfMoveButton from '../SelfMoveButton'
const placeholder = '/public/employee-avatar-placeholder.png'

export default ({
  data,
  user,
  sensitiveInfo = true,
  redirectToFloor,
  selectNeighborhood,
  close,
}) => {
  const {
    code,
    spaceAssignment: { employee, department, team },
  } = data
  const departmentInfo = getDepartmentInfo(department, team)
  const contactInfo = getContactInfo(employee)

  return (
    <Card>
      <Card.Image
        url={get(employee, 'assets[0].url', placeholder)}
        fullSizeUrl={get(employee, 'assets[0].fullSizeUrl')}
      />
      <Card.Details>
        <Card.Title>{employee.name}</Card.Title>
        <Card.Row label="title:" value={employee.title} />
        <Card.Row label="department:" value={departmentInfo} />
        {sensitiveInfo && <Card.Row label="contact:" value={contactInfo} />}
        {!employee.seat && !(employee.neighborhoods && employee.neighborhoods.length) && (
          <Card.Row
            label="space code:"
            value={
              code || (
                <span
                  style={{
                    color: '#9F4F48',
                    fontWeight: 'normal',
                    textTransform: 'capitalize',
                  }}
                >
                  Unseated
                </span>
              )
            }
          />
        )}
        {!employee.seat && employee.neighborhoods && employee.neighborhoods.length ? (
          <Card.Row
            label="Neighborhoods:"
            value={employee.neighborhoods.map((n) => (
              <a
                key={n.id}
                style={{ cursor: 'pointer' }}
                onClick={(e) => {
                  e.preventDefault()
                  selectNeighborhood && selectNeighborhood(n.id)
                  redirectToFloor && redirectToFloor(n.floor)
                  close && close(n.floor)
                }}
              >
                {n.name}
              </a>
            ))}
          />
        ) : null}
        {sensitiveInfo && (
          <tr>
            <td colSpan={2}>
              <SelfMoveButton space={data} user={user} />
            </td>
          </tr>
        )}
      </Card.Details>
    </Card>
  )
}

const getDepartmentInfo = (department, team) => {
  let departmentInfo

  if (department) {
    departmentInfo = [department.name]
  }
  if (team) {
    departmentInfo = departmentInfo ? [...departmentInfo, team.name] : [team.name]
  }

  return departmentInfo || 'N/A'
}

export const getContactInfo = ({ phone, email }) => {
  let contactInfo

  if (phone) {
    contactInfo = [phone]
  }

  if (email) {
    const emailEl = (
      <span
        key="email"
        style={{
          color: 'rgba(112, 112, 112, 0.5)',
          fontSize: 10,
          textTransform: 'lowercase',
          fontWeight: 'normal',
        }}
      >
        {email}
      </span>
    )
    contactInfo = contactInfo ? [...contactInfo, emailEl] : [emailEl]
  }

  return contactInfo || 'N/A'
}
